import React from 'react';
import DashboardGrid from '../features/dashboard/DashboardGrid';

const HRDashboard = () => <DashboardGrid kind="hr" />;

export default HRDashboard;
